// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Signature box shared by the safety and apprenticeship pages (and their dialogs, which get the
   page class as rootClassName). */

:is(.safety-page, .apprenticeship-page) .sf-signature-label {
  margin-bottom: var(--ds-space-2);
  font-weight: 600;
}

:is(.safety-page, .apprenticeship-page) .sf-signature-box {
  position: relative;
  border: 2px dashed var(--ds-border);
  border-radius: var(--ds-radius-md, 10px);
  background: #fff;
  margin-bottom: var(--ds-space-3);
}

:is(.safety-page, .apprenticeship-page) .sf-signature-box .wr-signature-canvas {
  display: block;
  width: 100%;
  height: 200px;
  touch-action: none;
  cursor: crosshair;
}

:is(.safety-page, .apprenticeship-page) .sf-signature-hint {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9aa7b2;
  font-size: 18px;
  pointer-events: none;
}

:is(.safety-page, .apprenticeship-page) .sf-signature-clear {
  position: absolute;
  inset-block-start: 8px;
  inset-inline-end: 8px;
}

@media (max-width: 767px) {
  :is(.safety-page, .apprenticeship-page) .sf-signature-box .wr-signature-canvas {
    height: 40vh;
    min-height: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/safety/signature.css"],"names":[],"mappings":"AAAA;kCACkC;;AAElC;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":["/* Signature box shared by the safety and apprenticeship pages (and their dialogs, which get the\n   page class as rootClassName). */\n\n:is(.safety-page, .apprenticeship-page) .sf-signature-label {\n  margin-bottom: var(--ds-space-2);\n  font-weight: 600;\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-signature-box {\n  position: relative;\n  border: 2px dashed var(--ds-border);\n  border-radius: var(--ds-radius-md, 10px);\n  background: #fff;\n  margin-bottom: var(--ds-space-3);\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-signature-box .wr-signature-canvas {\n  display: block;\n  width: 100%;\n  height: 200px;\n  touch-action: none;\n  cursor: crosshair;\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-signature-hint {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9aa7b2;\n  font-size: 18px;\n  pointer-events: none;\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-signature-clear {\n  position: absolute;\n  inset-block-start: 8px;\n  inset-inline-end: 8px;\n}\n\n@media (max-width: 767px) {\n  :is(.safety-page, .apprenticeship-page) .sf-signature-box .wr-signature-canvas {\n    height: 40vh;\n    min-height: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
